import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import FormikForm from "components/shared/FormikForm";
import { useDispatch } from "react-redux";
import { addRoundMultiplierApi, editRoundMultiplierApi } from "store/actions";
import Validation from "views/roundMultiplier/Validation";

export default function AddRoundMultiplierModal({
  show,
  handleClose,
  rowData,
  loading
}) {

  const dispatch = useDispatch();
  const refForm = useRef();

  const inputFields = [
    {
      name: "roundType",
      type: "number",
      label: "Round Type",
      placeholder: "Enter Round Type...",
      min: 1,
    },
    {
      name: "energySpent",
      type: "number",
      label: "Energy Spent",
      placeholder: "Enter Energy Spent...",
      min: 1,
    },
    {
      name: "btncRewardReceived",
      type: "number",
      label: "BTNc Reward Received",
      placeholder: "Enter BTNc Reward Received...",
      min: 1,
    },
    {
      name: "coinRewardReceived",
      type: "number",
      label: "Coin Reward Received",
      placeholder: "Enter Coin Reward Received...",
      min: 1,
    },
    {
      name: "jackpotRewardReceived",
      type: "number",
      label: "Jackpot Reward Received",
      placeholder: "Enter Jackpot Reward Received...",
      min: 1,
    },
    {
      name: "leaderboardPointsEarned",
      type: "number",
      label: "Leaderboard Points Earned",
      placeholder: "Enter Leaderboard Points Earned...",
      min: 1,
    },
    {
      name: "shortDescription",
      type: "text",
      label: "Short Description",
      placeholder: "Enter Short Description...",
    },
  ];

  // Blank instead of 0, so placeholders show and fields don't look pre-filled
  const initialValues = {
    roundType: "",
    energySpent: "",
    btncRewardReceived: "",
    coinRewardReceived: "",
    jackpotRewardReceived: "",
    leaderboardPointsEarned: "",
    shortDescription: "",
  };

  useEffect(() => {

    if (refForm.current) {

      if (rowData?._id) {
        refForm.current.setValues({
          roundType: rowData?.roundType ?? "",
          energySpent: rowData?.energySpent ?? "",
          btncRewardReceived: rowData?.btncRewardReceived ?? "",
          coinRewardReceived: rowData?.coinRewardReceived ?? "",
          jackpotRewardReceived: rowData?.jackpotRewardReceived ?? "",
          leaderboardPointsEarned: rowData?.leaderboardPointsEarned ?? "",
          shortDescription: rowData?.shortDescription || "",
        });
      } else {
        refForm.current.resetForm();
      }

    }

  }, [rowData]);

  const handleSubmit = (values) => {

    if (rowData?._id) {

      dispatch(editRoundMultiplierApi({
        data: { ...values, _id: rowData._id },
        callback: (err) => {
          if (!err) handleClose();
        }
      }));

    } else {

      dispatch(addRoundMultiplierApi({
        data: values,
        callback: (err) => {
          if (!err) handleClose();
        }
      }));

    }

  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">
          {rowData ? "Update" : "Add"} Round Multiplier
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormikForm
          ref={refForm}
          initialValues={initialValues}
          validationSchema={Validation}
          onSubmit={handleSubmit}
          loading={loading}
          inputFields={inputFields}
          buttonText="Submit"
          col={6}
        />
      </Modal.Body>
    </Modal>
  );
}